module.exports = __webpack_public_path__ + "f16243f7796cc03f9d62240087579db1.svg";